import React from 'react';
import { motion } from 'framer-motion';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  elevation?: 'none' | 'soft' | 'medium' | 'premium';
  interactive?: boolean;
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  elevation = 'soft',
  interactive = false,
}) => {
  const elevationClasses = {
    none: '',
    soft: 'shadow-sm',
    medium: 'shadow-md',
    premium: 'shadow-premium',
  };

  const baseClasses = 'bg-white rounded-lg overflow-hidden';
  const interactiveClasses = interactive
    ? 'transition-all duration-300 hover:shadow-premium hover:-translate-y-1'
    : '';

  return (
    <motion.div
      className={`${baseClasses} ${elevationClasses[elevation]} ${interactiveClasses} ${className}`}
      whileHover={interactive ? { y: -5 } : {}}
      transition={{ type: 'spring', stiffness: 300 }}
    >
      {children}
    </motion.div>
  );
};

export default Card;